module.exports = __webpack_public_path__ + "img/dark-s_pz.6f63b2bb.jpg";